/**
 * error thrown by apiRequest when a call fails, carrying the http status so
 * callers can branch on it instead of parsing messages. modules that send a
 * machine-readable error code expose it as `code`; branch on `error.code === 'X'`
 * @param message - human readable message, usually the api's own `message` field
 * @param status - http status code, or null when the request never went out
 * @param code - machine-readable api error code, when the module sends one
 * @param details - structured extra info sent along with the code
 * @param body - parsed response body, kept for debugging
 */
export default class ApiError extends Error {
  constructor({
    message = 'Request failed',
    status = null,
    code = null,
    details = null,
    body = null
  } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.body = body;
  }

  // the api cannot tell "expired token" apart from "not allowed here", so both
  // arrive as a 401 and the caller decides what to render
  get isNoAccess() {
    return this.status === 401;
  }

  get isNotFound() {
    return this.status === 404;
  }
}
